<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">サイネージ表示画像インポート</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-margin uk-margin-bottom" style="position: relative">
			<div style="position: absolute; top:0;right:0;">
				<router-link class="uk-button uk-button-default" to="/shop">戻る</router-link>
			</div>
			<h1 class="uk-margin-remove-top uk-heading-divide uk-text-center">インポート</h1>
			<div class="uk-margin uk-text-center">
				<input id="file" type="file">
			</div>
			<div class="uk-margin-small uk-text-center">
				<p>指定されたファイルをインポートします。よろしいですか。</p>
				<p>※ 登録する画像サイズは5MB以下にしてください。</p>
			</div>
			<div class="uk-margin uk-text-center">
				<template v-if="uploaded_files.length >= 5">
					<button class="uk-button uk-button-default" style="background: #EEE" disabled>インポート</button>
				</template>
				<template v-else>
					<button class="uk-button uk-button-default" @click="upload">インポート</button>
				</template>
			</div>
			<h1 class="uk-heading-divide uk-text-center">現在インポートされている画像</h1>
			<table class="uk-table">
				<template v-for="file in uploaded_files">
					<tr :key="file">
						<td>{{file}}</td>
						<td>
							<button class="uk-button uk-button-default" @click="file_delete(file)">削除</button>
						</td>
					</tr>
				</template>
			</table>
			<div class="uk-margin uk-text-center uk-text-bold">
				<p>登録できる画像は5枚までです。</p>
				<p>追加する場合は、登録済み画像の削除が必要です。</p>
			</div>
			<div class="uk-margin uk-text-center">
				<p>インポートには時間がかかります。</p>
				<p>ステータスが異常になった場合は、インポートをやり直してください。</p>
				<p>最終更新日時: {{ last_updated | moment }}</p>
			</div>
		</div>
	</div>
</template>

<script>

	import SignageFile from '@/api/SignageFile'
	import StaffAuth from '@/api/StaffAuth'
	import Role from '@/api/Role'
	import Tag from '@/api/Tag'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'

	export default {
		name: 'ShopSignageFileImportPage',
		comments: [],
		data () {
			return {
				last_updated: null,
				current_staff: null,
				uploaded_files: []
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			download (file_name, file_path) {
				StaffAuth.current().then(function (response) {
					let url = S3_URL + file_path

					let xhr = new XMLHttpRequest()
					xhr.open('GET', url, true)
					xhr.responseType = 'blob'
					xhr.onload = function (event) {
						let blob = xhr.response

						if (window.navigator.msSaveBlob) {
							window.navigator.msSaveBlob(blob, file_name)
						} else {
							let objectURL = window.URL.createObjectURL(blob)
							let link = document.createElement('a')

							document.body.appendChild(link)

							link.href = objectURL
							link.download = file_name
							link.click()

							document.body.removeChild(link)
						}
					}

					xhr.send()
				})
			},
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			load_files () {
				let self = this
				SignageFile.get().then(function (response) {
					self.uploaded_files = response.data.data.file_name
				})
			},
			upload () {
				let params = new FormData()
				params.append('file', $('#file')[0].files[0])

				SignageFile.import(params).then(function (response) {
					alert('完了いたしました')
					window.location.reload()
				}, function () {
					alert('ERROR')
				})
			},
			file_delete (file_name) {
				if (window.confirm('本当に削除しますか？')) {
					let params = new URLSearchParams()
					params.append('file_name', file_name)

					SignageFile.delete(params).then(function (response) {
						window.location.reload()
					})
				}
			}
		},
		created () {
			this.load_files()
		},
		beforeMount () {
		},
		mounted () {
			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 管理者スタッフではない場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data

				let params = new URLSearchParams()
				params.append('key', 'last_import_signage_file[' + self.current_staff.shop_id + ']')

				Tag.one(params).then(function (response) {
					self.last_updated = moment(response.data.data.value).format('YYYY-MM-DD HH:mm:ss')
				})
			})
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/ShopSignageFileImportPage.vue